export const selectActiveCategory = (state) => state.mainReducer.activeCategory;
